import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  FLAG_GETTING_PERSONS,
  GET_PERSONS,
  CLEAR_PERSONS,
  SET_PERSON_INPUT_FOCUS,
  CLEAR_PERSON_INPUT_FOCUS,
  SET_FOCUS_CUSTOMER,
  CLEAR_FOCUS_CUSTOMER,
  CLEAR_PASSENGER_LIST,
  SET_PASSENGER_LIST,
} from '../types';
import { CUSTOMER_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingPersons = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_PERSONS,
    payload: flag,
  });


const getPersons =
  async ({ document, mode }) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingPersons(true));
        const query = { document, mode }
        const url = `${CUSTOMER_ENDPOINT}/search?${QueryString.stringify(query)}`;
        const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
        await isErrorResponse(response, null, dispatch);
        const persons = await response.json();
        dispatch({ type: GET_PERSONS, payload: { content: persons } });
        return persons;
      } catch ({ message }) {
        toastr.error('Error', message);
        return [];
      } finally {
        dispatch(flagGettingPersons(false));
      }
    }

const clearPersons = () => (dispatch) =>
  dispatch({
    type: CLEAR_PERSONS,
  });


const addPersonInputFocus = async () => async (dispatch, getState) =>
  dispatch({
    type: SET_PERSON_INPUT_FOCUS,
    payload: getState().UserUnit.Person.get('inputFocus').get('index') + 1,
  });

const setPersonInputFocus = (index) => (dispatch) =>
  dispatch({
    type: SET_PERSON_INPUT_FOCUS,
    payload: index,
  });

const clearPersonInputFocus = () => (dispatch) =>
  dispatch({
    type: CLEAR_PERSON_INPUT_FOCUS,
  });

const setFocusCustomer = () => (dispatch) =>
  dispatch({
    type: SET_FOCUS_CUSTOMER,
  });

const clearFocusCustomer = () => (dispatch) =>
  dispatch({
    type: CLEAR_FOCUS_CUSTOMER,
  });

const setPassengerList = (list) => (dispatch) =>
  dispatch({
    type: SET_PASSENGER_LIST,
    payload: list,
  });

const clearPassengerList = () => (dispatch) =>
  dispatch({
    type: CLEAR_PASSENGER_LIST,
  });

export {
  getPersons,
  clearPersons,
  setPersonInputFocus,
  clearPersonInputFocus,
  setFocusCustomer,
  clearFocusCustomer,
  addPersonInputFocus,
  setPassengerList,
  clearPassengerList,
};
